module.exports = __webpack_public_path__ + "img/empty-profile-female.1929d5b7.svg";